// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getClaimsForAudit} from '../../shared/repositories';
import {initializeList} from './search-filters';

export const readClaims = (accounts, facets, searchFilters) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const accountsArray = typeof accounts === 'string' ? [accounts] : accounts;
            const claims = await getClaimsForAudit(accountsArray, facets);

            dispatch({
                data: claims,
                type: actions.UPDATE_TCSM_AUDIT_CLAIM_SEARCH_RESULTS
            });

            dispatch(initializeList(claims, searchFilters));

        } catch (error) {
        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };




// WEBPACK FOOTER //
// ./src/tcsm/claim-search/action-creators/get-claim-results.js